import { render } from "./Help.vue?vue&type=template&id=947f23a8&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-947f23a8"

export default script